// extracted by mini-css-extract-plugin
export default {"tab":"tnVy7","text":"Px_iF","tabActive":"LSTh5","icon":"vjmdC"};